import * as Yup from "yup";

const CVValidation = Yup.object({
    firstName: Yup.string().required("First Name is Required"),
    middleName: Yup.string().required("Middle Name is Required"),
    lastName: Yup.string().required("Last Name is Required"),

    cv: Yup.mixed().when("id", {
        is: (id) => !id,
        then: Yup.mixed().required("Attachment is required"),
    }),
});

export default CVValidation;
